import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  PrimaryTypography,
  SecondaryTypography,
} from '../../../ui/typography/typography';
import { Tabs } from '../../assessment/view/tabs/tabs';
import baseStyles from '../admin.module.css';
import { EntityManagement } from './EntityManagement';
import { PartnerEmployeeManagement } from './PartnerEmployeeManagement';

export const PartnerManagement = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const tabTitles = ['Entities', 'Employees'];

  const renderTabContent = () => {
    if (activeTab === 0) {
      return <EntityManagement />;
    } else if (activeTab === 1) {
      return <PartnerEmployeeManagement />;
    }
  };

  return (
    <div className='w-full h-full flex flex-col gap-5'>
      <nav
          className='flex w-full justify-between items-center border-b py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Admin
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-dark font-semibold hover:underline'
            >
              Partner Management
            </Link>
          </li>{ ' ' }
          <li>
            <span className='text-gray-400'>/</span>
          </li>
        </ol>
      </nav>
      <div>
        <Tabs
            tabTitles={tabTitles}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        />
        { renderTabContent() }
      </div>
    </div>
  );
};
